// extracted by mini-css-extract-plugin
export default {"container":"Header_container__ogplU","header":"Header_header__d+igc","logo":"Header_logo__hLUwo"};